<div class="flex flex-col -m-6">
  <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'pwdChangeAdminTitle' | transloco:{ user: user.displayName } }}</div>
  </div>
  <div class="flex flex-col p-4 sm:px-8 w-full">
    <p class="mb-2">{{ 'passwordRules' | transloco }}</p>
    <mat-form-field appearance="fill" class="py-2">
      <mat-label>{{ 'newPassword' | transloco }}</mat-label>
      <input matInput pwdChangeDirective [type]="hideNewPassword ? 'password' : 'text'" required [formControl]="newPassword"
        autocomplete="new-password" (input)="onChangeInput($event)">
        <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword" [attr.aria-label]=" ('hidePassword' | transloco )" [attr.aria-pressed]="hideNewPassword">
          <mat-icon [svgIcon]="hideNewPassword ? 'heroicons_outline:eye-off' : 'heroicons_outline:eye'"></mat-icon>
        </button>
        @if (newPassword.invalid) {
          <mat-error>{{getErrorMessageNewPassword()}}</mat-error>
        }
      </mat-form-field>
      <div class="flex flex-col ml-7">
        <div class="flex flex-row items-center mb-1">
          <mat-icon class="mr-1" [svgIcon]="!nCharsValid ? 'feather:circle' : 'feather:check-circle'"></mat-icon> &nbsp;
          <mat-label>{{ 'NEW_PASSWORD_MSG_NCHARS' | transloco:{ nChars: nChars } }}</mat-label> <br>
        </div>
        <div class="flex flex-row items-center mb-1">
          <mat-icon class="mr-1" [svgIcon]="!charMayus ? 'feather:circle' : 'feather:check-circle'"></mat-icon> &nbsp;
          <mat-label>{{ 'NEW_PASSWORD_MSG_CHARMAYUS' | transloco }}</mat-label> <br>
        </div>
        <div class="flex flex-row items-center mb-1">
          <mat-icon class="mr-1" [svgIcon]="!charMinus ? 'feather:circle' : 'feather:check-circle'"></mat-icon> &nbsp;
          <mat-label>{{ 'NEW_PASSWORD_MSG_CHARMINUS' | transloco }}</mat-label> <br>
        </div>
        <div class="flex flex-row items-center mb-2">
          <mat-icon class="mr-1" [svgIcon]="!charNum ? 'feather:circle' : 'feather:check-circle'"></mat-icon> &nbsp;
          <mat-label>{{ 'NEW_PASSWORD_MSG_CHARNUM' | transloco }}</mat-label>
        </div>
        <div class="flex flex-row items-center mb-2">
          <mat-icon class="mr-1" [svgIcon]="!charSpecial ? 'feather:circle' : 'feather:check-circle'"></mat-icon> &nbsp;
          <mat-label>{{ 'NEW_PASSWORD_MSG_SPECIALCHAR' | transloco }}</mat-label>
        </div>
      </div>
      <mat-form-field appearance="fill" class="py-2">
        <mat-label>{{ 'confirmPassword' | transloco }}</mat-label>
        <input matInput pwdChangeDirective [type]="hideConfirmPassword ? 'password' : 'text'" required [formControl]="confirmPassword" autocomplete="new-password">
        <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-label]="( 'hidePassword' | transloco )" [attr.aria-pressed]="hideConfirmPassword">
          <mat-icon [svgIcon]="hideConfirmPassword ? 'heroicons_outline:eye-off' : 'heroicons_outline:eye'"></mat-icon>
        </button>
      </mat-form-field>
      <div class="flex flex-col w-full items-end">
        <div class="px-8 py-4">
          <button mat-raised-button class="mx-2" (click)="closeDialog()">{{ 'cancel' | transloco }}</button>
          <button mat-raised-button color="primary" class="mx-2" (click)="submitPassword()">{{ 'save' | transloco }}</button>
        </div>
      </div>
    </div>
  </div>